import { useLazyQuery } from '@apollo/client'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import {
  buildFeatureSet,
  getCredentials,
  hasRequiredFeatures
} from '../../cache/auth'
import PageHeader from '../../components/PageHeader'
import { FileStatus, ImageProps } from '../../components/UploadBox/ImageBox'
import { UploadBox } from '../../components/UploadBox/index'
import { ACCOMMODATION_LOGO_QUERY } from '../../graphql/upload'
import accommodationPagesRoleManagement from '../../staticRoleManagement/accommodationsRoleManagement'
import { Image } from '../../types/image'

interface UploadBoxForAccommodationLogoProps {
  title: string
}

export const UploadBoxForAccommodationLogo: React.FC<
  UploadBoxForAccommodationLogoProps
> = ({ title }) => {
  const [images, setImages] = useState<ImageProps[]>([])
  const params = useParams<{
    accID: string
    propertyCode: string
  }>()

  const [getLogoImage, { data, loading }] = useLazyQuery<{
    accommodationLogo: Image
  }>(ACCOMMODATION_LOGO_QUERY, {
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    getLogoImage({
      variables: {
        propertyCode: params.propertyCode
      }
    })
  }, [])

  useEffect(() => {
    if (data) {
      let newImages: ImageProps[] = []

      newImages = [
        {
          fileURL: data.accommodationLogo.url,
          status: FileStatus.COMPLETED,
          fileName: data.accommodationLogo.name,
          fileSize: data.accommodationLogo.size,
          mediaID: data.accommodationLogo.id
        }
      ]
      setImages(newImages)
    }
  }, [loading, data])

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const hasAccessToUploadLogo = hasRequiredFeatures(
    accommodationPagesRoleManagement
      .find(
        (item) => item.route === '/accommodations/:accID/:propertyCode/:page'
      )
      ?.tabs?.find((tabItem) => tabItem.params.page === 'logo')
      ?.requiredFeatures,
    featureSet
  )

  return (
    <>
      <PageHeader title={title} />
      <UploadBox
        hasAccess={hasAccessToUploadLogo}
        loading={loading}
        entityCode={params.propertyCode}
        entityid={params.accID}
        entityType={'Accommodation'}
        images={images}
        setImages={setImages}
        imageType={'Logo'}
      />
    </>
  )
}
